import React, { FunctionComponent } from 'react';

import { SegmentedControlOptions } from 'scenes/common/components/Questions';
import { SingleSegmentedControlStep } from 'scenes/common/components/Steps';

import { getPurposeOfProperty } from 'scenes/landlord/selectors';
import {
  LandlordFullPageProps,
  PropertyPurposeType,
} from 'scenes/landlord/types';

export const STATE_KEY = 'purposeOfProperty';
export const QUESTION = 'What do you do with the property?';

const PROPERTY_PURPOSES_OPTIONS: SegmentedControlOptions<
  PropertyPurposeType,
  PropertyPurposeType
> = [
  {
    label: PropertyPurposeType.Rental,
    value: PropertyPurposeType.Rental,
  },
  {
    label: PropertyPurposeType.ShortTermRental,
    value: PropertyPurposeType.ShortTermRental,
  },
  { label: PropertyPurposeType.PPR, value: PropertyPurposeType.PPR },
  {
    label: PropertyPurposeType.HolidaysHouse,
    value: PropertyPurposeType.HolidaysHouse,
  },
];

const PropertyPurposeStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleSegmentedControlStep
    stack
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    options={PROPERTY_PURPOSES_OPTIONS}
    defaultStateValue={getPurposeOfProperty(funnelState)}
  />
);

export default PropertyPurposeStep;
